import { Fonts } from '../../../../../shared/theme';
import colors from '../../../../../shared/theme/colors';
import { textStyles } from '../../../../../shared/theme/fonts-ppv';

export default {
  addBranchText: {
    paddingLeft: 20,
    color: '#4B2885',
    cursor: 'pointer',
    fontFamily: 'Kanit-Regular'
  },
  addBranchTextInner: {
    textDecoration: 'underline'
  },
  option_promotion: {
    color: '#D3329A',
    ...textStyles.subtitle2
  },
  remark: {
    marginTop: 8,
    whiteSpace: 'pre-line',
    color: colors.font.primary.fakeBlack
  },
  warning: {
    marginTop: 24,
    whiteSpace: 'pre-line',
    color: colors.font.messaging.lightRed,
    textAlign: 'center',
    ...textStyles.subtitle2,
    fontSize: 14
  },
  tagPickerRemark: {
    whiteSpace: 'pre-line',
    color: colors.font.messaging.lightRed,
    fontFamily: 'Kanit-Light',
    fontSize: 14
  },
  inlineBlock: {
    display: 'inline-block',
  },
  iconPlus: {
    paddingRight: '4px'
  },
	discountBox: {
		padding: 16,
		border: '1px solid #D9D9D9',
		borderRadius: 16,
		width: '480px'
	}
};

export const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 16 },
};

